import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default class CreditRedemption extends ApplicationSerializer {}